import {
  ReactNode,
  ComponentPropsWithoutRef,
  forwardRef,
  ForwardedRef
} from 'react';
import { Container, CheckMark } from './style';

interface IRadioButtonProps extends ComponentPropsWithoutRef<'input'> {
  children: ReactNode;
  name: string;
  checked?: boolean;
  className?: string;
}

const RadioButton = (
  props: IRadioButtonProps,
  ref: ForwardedRef<HTMLInputElement>
) => {
  const { children, name, checked, className, ...rest } = props;
  return (
    <div className={className}>
      <Container>
        {children}
        <input type="radio" name={name} checked={checked} {...rest} ref={ref} />
        <CheckMark />
      </Container>
    </div>
  );
};

export default forwardRef(RadioButton);
